/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
// material
import { Division, InContentMessage, Page } from '@insticator/insticator-ui'; // iui-material
// pages
import CompanyPage from './company/company'

// utils

// thunks

// styles
import injectSheet from 'react-jss';
import styles from './profile_styles';



/* ========== ~~~~~~~~~~ COMMENTING DIVISION ~~~~~~~~~~ ========== */

export default injectSheet(styles)((props) => (
    <Division name={`profile`} klass={props.classes.profile}>
        <InContentMessage/>
        <Switch>
            {/*Routes to subdivisions*/}
            <Route exact path='/profile' render={() => <Redirect to={'profile/company'} />} />
            <Route path='/profile/company' component={CompanyPage} />
            <Redirect to='/error/404'/>
        </Switch>
    </Division>
));
